import React from 'react';
import {motion} from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 md:py-48 bg-brand-primary border-y border-brand-secondary/30 relative overflow-hidden">
      <div className="absolute inset-0 bg-brand-secondary/5 z-0"></div>
      <div className="container relative z-10 mx-auto px-6 md:px-12 flex justify-center text-center">
        <motion.div 
          initial={{opacity: 0,y: 20}} 
          whileInView={{opacity: 1,y: 0}} 
          viewport={{once: true}} 
          transition={{duration: 0.8}} 
          className="max-w-5xl" 
        >
          <span className="text-xs tracking-[0.3em] uppercase text-brand-accent font-semibold mb-10 block">Corporate Structure</span>
          
          {/* Section Heading - Unchanged */}
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-light text-white mb-12 tracking-tight leading-tight text-balance">
            An independent platform for building, developing and connecting business opportunities.
          </h2>

          {/* Updated Descriptive Body Text - Two Paragraphs */}
          <div className="text-brand-light/90 text-xl md:text-2xl font-light leading-relaxed space-y-8 max-w-4xl mx-auto text-balance mb-16">
            <p>
              EPOQ Assets is the platform behind a growing group of ventures built around technology, transformation and long-term business development. We identify opportunities, bring together the right people and capabilities, and develop focused businesses that can move from idea to practical execution.
            </p>
            <p className="text-brand-light/70">
              Our activities currently span strategic consulting, autonomous mobility, AI talent development and emerging business opportunities. Each venture has its own focus and identity, while sharing a common approach: practical innovation, strong partnerships and creating lasting value.
            </p>
          </div>

          <a 
            href="#contact" 
            className="text-[14px] tracking-[0.2em] uppercase text-white font-semibold hover:text-brand-accent transition-colors border-b-2 border-brand-secondary pb-2 hover:border-brand-accent inline-block" 
          >
            Learn about our vision
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default About;